import { processMarkdownLine } from './processMarkdownLine';
import { parseTable, isTableLine } from './helpers/tableHelper';

const NEWLINE_SEPARATOR = '\n';

export async function parseMarkdownContent(markdownContent: string): Promise<{ elements: any[] }> {
    const elements: any[] = [];
    const lines = markdownContent.split(NEWLINE_SEPARATOR);
    let tableLines: string[] = [];
    let isTable = false;
    let order = 0;

    for (const line of lines) {
        if (isTableLine(line)) {
            tableLines.push(line);
            isTable = true;
        } else {
            if (isTable && tableLines.length > 0) {
                elements.push(createTableElement(parseTable(tableLines), order++));
                tableLines = [];
                isTable = false;
            }
            const lineElements = await processMarkdownLine(line);
            lineElements.forEach(el => elements.push({ ...el, order: order++ }));
        }
    }

    if (isTable && tableLines.length > 0) {
        elements.push(createTableElement(parseTable(tableLines), order++));
    }

    return { elements };
}

function createTableElement(content: any, order: number): any {
    return { type: 'table', content, order };
}
